export enum AnimationStyles {
  SHRINK_GROW = 'shrinkGrow',
  SCALE_IN_TO_SCALE_DOWN = 'scaleInToScaleDown',
}
